import { AlertCircle } from 'lucide-react';
import Header from './Header';

interface ErrorDisplayProps {
    error: string;
}

export default function ErrorDisplay({ error }: ErrorDisplayProps) {
    return (
        <div className="h-full flex flex-col bg-gray-50">
            <Header />
            <main className="flex-1 flex items-center justify-center p-4">
                <div className="max-w-md w-full bg-white rounded-xl shadow-sm p-8">
                    <div className="flex flex-col items-center text-center">
                        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-100 mb-4">
                            <AlertCircle className="w-8 h-8 text-red-600" />
                        </div>
                        <h1 className="text-2xl font-bold text-gray-900 mb-2">
                            Error
                        </h1>
                        <p className="text-gray-600">
                            {error}
                        </p>
                    </div>
                </div>
            </main>
        </div>
    );
}

